/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgRadioButtonToday = (props: Props) => (
  <Icon viewBox="0 0 20 20" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M10 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4z" />
        <path d="M15 10a5 5 0 1 1-10 0 5 5 0 0 1 10 0zm-1.25 0a3.75 3.75 0 1 0-7.5 0 3.75 3.75 0 0 0 7.5 0z" />
      </g>
    </g>
  </Icon>
);
export { SvgRadioButtonToday as RadioButtonToday };
